import React, { useState, useEffect } from 'react';
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from '../../../../_metronic/_partials/controls';
import axios, { baseUrl } from '../../../../redux/my-axios';
import Filter from './filter/Filter';
import List from './list/List';
import Total from './total/Total';

export const URL = '/finance';
const initialFilter = {
  filter: {
    from: '', //Date.now(),
    to: '', //"",
    searchText: '',
  },
  sortOrder: 'desc', // asc||desc
  sortField: 'code',
  pageNumber: 1,
  pageSize: 400,
};
export const FinanceSalesPage = (props) => {
  const [queryParams, setQueryParams] = useState(initialFilter);
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const [entities, setEntities] = useState([]);
  const [total, setTotal] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    axios
      .post(URL, queryParams, { headers: { action: 'getsales' } })
      .then((response) => {
        switch (response.data.type) {
          case 'SUCCESS':
          case 'SUCCESS_WITH_WARNING':
          case 'SUCCESS_WITH_INFO':
            console.log('Result ', response.data.data);
            setTotalCount(response.data.data.totalCount);
            setEntities(response.data.data.list);
            buildTotal(response.data.data.list);
            break;
          default:
            var error = response.data.msg.desc;
            setError(error);
            break;
        }
      })
      .catch((error) => {
        setError(error);
      });
    return () => {
      setEntities([]);
    };
  }, [queryParams]);

  const buildTotal = (entities) => {
    var sumSales = 0.0;
    var sumProfit = 0.0;
    var sumLost = 0.0;
    var sumOrder = 0.0;
    var sumShip = 0.0;
    var sumDelivered = 0.0;

    for (let i = 0; i < entities.length; i++) {
      if (entities[i].salesAmount)
        sumSales +=
          Math.round(
            (parseFloat(entities[i].salesAmount) + Number.EPSILON) * 100
          ) / 100;
      if (entities[i].profitAmount)
        sumProfit +=
          Math.round(
            (parseFloat(entities[i].profitAmount) + Number.EPSILON) * 100
          ) / 100;
      if (entities[i].lostAmount)
        sumLost +=
          Math.round(
            (parseFloat(entities[i].lostAmount) + Number.EPSILON) * 100
          ) / 100;
      if (entities[i].preOrderAmount)
        sumOrder +=
          Math.round(
            (parseFloat(entities[i].preOrderAmount) + Number.EPSILON) * 100
          ) / 100;
      if (entities[i].shipAmount)
        sumShip +=
          Math.round(
            (parseFloat(entities[i].shipAmount) + Number.EPSILON) * 100
          ) / 100;
      if (entities[i].deliveredAmount)
        sumDelivered +=
          Math.round(
            (parseFloat(entities[i].deliveredAmount) + Number.EPSILON) * 100
          ) / 100;
    }
    setTotal([
      {
        salesAmount: sumSales,
        profitAmount: sumProfit,
        lostAmount: sumLost,
        preOrderAmount: sumOrder,
        shipAmount: sumShip,
        deliveredAmount: sumDelivered,
      },
    ]);
  };

  return (
    <Card id='financeSalesCard'>
      <CardHeader title='САНХҮҮ: Борлуулалт'></CardHeader>
      <CardBody>
        <Filter queryParams={queryParams} setQueryParams={setQueryParams} />
        <h6>Нийт дүн</h6>
        <Total
          entities={total}
          totalCount={totalCount}
          setQueryParams={setQueryParams}
        />
        <b>Өдөр бүрийн дүн</b>
        <List
          entities={entities}
          totalCount={totalCount}
          setQueryParams={setQueryParams}
        />
      </CardBody>
    </Card>
  );
};
